import * as z from "zod/v4";

export const getProductByHandle = {
  name: "getProductByHandle" as const,
  input: z.object({ productHandle: z.string() }),
  output: z.object({
    id: z.string(),
    imageSrc: z.string().optional(),
    title: z.string(),
    variants: z.array(z.object({ id: z.string(), available: z.boolean() })),
  }),
};
